export default "__VITE_ASSET__RrN32gvu__"